import script from "./TclScanOut.vue?vue&type=script&setup=true&lang=js"
export * from "./TclScanOut.vue?vue&type=script&setup=true&lang=js"

import "./TclScanOut.vue?vue&type=style&index=0&id=038da42a&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038da42a"]])

export default __exports__